var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vuex-breadcrumb'),_c('profile-show',{attrs:{"id":_vm.id}}),_c('actor-role-index',{attrs:{"filtering":_vm.actor_filter,"refresh":_vm.refresh},on:{"refreshed":_vm.refreshed}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }